/**
 * Created by JasonChou on 17/6/14.
 */
const monent = require('moment');

export const gridHelper = (len, columnCount, i) => {
    const rowCount = Math.ceil(len / columnCount); //行数

    const rowIndex = Math.floor(i / columnCount); //当前行Index

    const columnIndex = (i % columnCount);

    const isTop = rowIndex === 0;
    const isBottom = rowIndex === rowCount - 1;


    const isLeft = columnIndex === 0;
    const isRight = columnIndex === columnCount - 1;

    return {
        isTop, isBottom, isLeft, isRight
    }
};

export const gridHelper2 = (len, rowCount, i) => {
    const columnCount = Math.ceil(len / rowCount); //列数

    const columnIndex = Math.floor(i / rowCount); //当前列Index

    const rowIndex = (i % rowCount); //当前行Index

    const isLeft = columnIndex === 0;
    const isRight = columnIndex === columnCount - 1;


    const isTop = rowIndex === 0;
    const isBottom = rowIndex === rowCount - 1;

    return {
        isTop, isBottom, isLeft, isRight
    }
};

/**
 *
 * @param url
 * @param width
 * @param height
 * @returns {*}
 */
export const imageCut = (url, {width, height}) => {

    if (url.match(/\?/)) //有参数的一律不处理
        return url;

    let density = 3;

    width = Math.floor(width);
    height = Math.floor(height);

    if (height && width)
        return url + `?imageView2/1/w/${width * density}/h/${height * density}`

    url += '?imageView2/2';

    if (width)
        url += `/w/${width * density}`;
    else if (height)
        url += `/h/${height * density}`;

    return url;
};


export const merge = function () {
    return Object.assign({}, ...arguments);
};


export const feedShowCreateTime = (timeStr) => {

    const time = monent(timeStr, 'YYYY-MM-DD HH:mm:ss');

    const seconds = parseInt((Date.now() - time.valueOf() ) / 1000);

    if (seconds < 60 * 5) {
        return '刚刚'
    } else if (seconds < 60 * 60) {
        return `${Math.floor(seconds / 60)}分钟以前`
    } else if (seconds < 60 * 60 * 24) {
        return `${Math.floor(seconds / 60 / 60)}小时前`
    } else {
        return time.format('M月D日 H点')
    }
};


// WEBPACK FOOTER //
// ./src/utils/uiUtils.js